import {Component, Input, OnInit} from '@angular/core';
import {BaseModalComponent} from "common-shared";
import {EventModel, EventService} from "../event-list/event.service";

@Component({
  selector: 'app-event-view',
  templateUrl: './event-view-modal.component.html',
  styles: []
})
export class EventViewModalComponent extends BaseModalComponent implements OnInit {
  @Input() event: EventModel;
  json: string = '';
  text: string;

  constructor(public eventService: EventService) {
    super();
  }

  ngOnInit(): void {
    this.tryParseJSON(this.event.Content);
  }

  tryParseJSON(jsonString) {
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        this.json = o;
      }
    } catch (e) {
    }
      this.text = jsonString;
  };
}
